var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrProfessional({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 50,
    height: 50,
    transform: "translate(-0.249 -0.427)",
    fill: "none",
    stroke: "#773dbd",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0.249 0.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 3.5,
    cy: 4,
    rx: 3.5,
    ry: 4,
    transform: "translate(5.751 0.573)",
    fill: "none",
    stroke: "#773dbd",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M5.648,22.818V29.79H1V18.17a5.423,5.423,0,0,1,5.423-5.423H27.339v4.648H14.944V29.79H49.03V5H15.719",
    transform: "translate(-0.353 -1.255)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 29,
    transform: "translate(17.751 25.573)",
    fill: "none",
    stroke: "#773dbd",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M43.608,54l5.423,3.1v1.549c0,1.284-.775,2.324-1.549,2.324H2.549C1.775,60.972,1,59.932,1,58.648V57.1L6.423,54",
    transform: "translate(-0.353 -12.295)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M35,54l6.2,3.1L46.62,54",
    transform: "translate(-8.014 -12.295)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M14,54l5.423,3.1,6.2-3.1",
    transform: "translate(-3.282 -12.295)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M13.747,47.261c0,2.711-1.521,5.035-3.873,5.035S6,49.972,6,47.261,6.775,43,9.873,43,13.747,44.549,13.747,47.261Z",
    transform: "translate(-1.48 -9.817)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M34.747,47.261c0,2.711-1.521,5.035-3.873,5.035S27,49.972,27,47.261,27.775,43,30.873,43,34.747,44.549,34.747,47.261Z",
    transform: "translate(-6.212 -9.817)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M55.747,47.261c0,2.711-1.521,5.035-3.873,5.035S48,49.972,48,47.261,48.775,43,51.873,43,55.747,44.549,55.747,47.261Z",
    transform: "translate(-10.943 -9.817)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    y2: 3,
    transform: "translate(16.751 44.573)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y2: 3,
    transform: "translate(32.751 44.573)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y2: 1,
    transform: "translate(8.751 13.573)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y2: 1,
    transform: "translate(8.751 17.573)",
    fill: "none",
    stroke: "#773dbd",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrProfessional);
export default __webpack_public_path__ + "static/media/hr-professional.b6d51f298b46c75b4427bd8cb63c84ca.svg";
export { ForwardRef as ReactComponent };